<template>
  <div>
    <v-row no-gutters v-for="(button, i) in buttons" :key="i">
      <button v-ripple class="chat-btn chat-widget hover-btn text-none" :style="`color: ${config.main_color}`" variant="outlined" @click="click(button)">{{ button.title }}</button>
    </v-row>
  </div>
</template>

<script setup>
// Import config
import global_config from '@/../config.json'
// Import modules
import { ref, defineProps } from 'vue'
import { useStore } from 'vuex'

// Init modules
const store = useStore()

// data
const config = ref(global_config)

// props
const { buttons } = defineProps({
  buttons: Array
})

// Methods
const click = ({ type, title, value }) => {
  if (type === 'web_url') window.open(value, '_blank')
  else store.dispatch('sendMessageToSocket', { title, value })
}
</script>

<style scope></style>
